var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ant-skeleton ant-skeleton-active"},[_c('div',{staticClass:"ant-skeleton-content"},[_c('h3',{staticClass:"ant-skeleton-title",staticStyle:{"width":"38%"}}),_vm._v(" "),_c('ul',{staticClass:"ant-skeleton-paragraph"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li',{staticStyle:{"width":"61%"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adb79b1e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utilities/Skeleton.vue
// module id = 387
// module chunks = 0